<template>
  <div>
    <h1 class="mb-1">Histórico de alteração de escritório</h1>
    <div v-if="loading" class="d-flex justify-content-center">
      <b-spinner variant="primary" />
    </div>
    <template v-else>
      <b-table
        hover
        :items="details"
        borderless
        responsive
        :fields="tableColumns"
        show-empty
        empty-text="Não foram encontradas alterações de escritório para este consultor"
        :busy="loading"
      >
        <template #cell(date)="data">
          <div class="text-wrap">
            <span class="align-text-top">{{ data.item.date | onlyDate }}</span>
          </div>
        </template>
      </b-table>
    </template>
  </div>
</template>

<script>
import { BSpinner, BTable } from "bootstrap-vue";
import { mapActions } from "vuex";
import * as types from "@/modules/consultant/store/types";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent";

export default {
  components: {
    BSpinner,
    BTable,
  },
  setup() {
    return { toast: useToast() };
  },
  data() {
    return {
      loading: false,
      tableColumns: [
        { key: "previous_physical_franchise_name", label: "Escritório anterior" },
        { key: "new_physical_franchise_name", label: "Novo escritório" },
        { key: "changed_by_user_name", label: "Alterado por" },
        { key: "reason", label: "Motivo" },
        { key: "ticket_number", label: "Nº do chamado" },
        { key: "date", label: "Data" },
      ],
      details: [],
    };
  },
  mounted() {
    this.loading = true;
    this.getPhysicalFranchiseChangeHistory(this.$route.params.id)
      .then((response) => {
        this.details = response.data;
      })
      .catch(() => {
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Oops!",
            text: "Ocorreu um erro ao obter o histórico de escritório do PN. Entre em contato com o setor de TI.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    ...mapActions({
      getPhysicalFranchiseChangeHistory: types.GET_PHYSICAL_FRANCHISE_CHANGE_HISTORY,
    }),
  },
};
</script>
